import { gql } from "@apollo/client";
import MapPointFragment from "@components/MapPoint/MapPoint.fragment";

export default gql`
  ${MapPointFragment}
  fragment MapFragment on MapParagraph {
    id
    mapPointsList {
      ...MapPointFragment
    }
  }
`;
